<template>
    <div class="penalty">
      <div class="team-box flex-center">
            <div class="team">
                <img :src="imageView(homeTeam.badge,120,120)" />
                <p>{{ homeTeam.name }}</p>
            </div>
            <img src="http://images.snsports.cn/s365-vs.png" class="vs" />
            <div class="team">
                <img :src="imageView(awayTeam.badge, 120, 120)" />
                <p>{{ awayTeam.name }}</p>
            </div>
      </div>
      <div class="list">
        <div class="item" v-for="item in list" :key="item.round">
            <div class="title flex-center">
                <div>第{{ item.round }}轮</div>
                <div class="delete" @click="deleteRound(item.round)" v-if="item.round >=6 && item.round === list.length"><van-icon name="delete-o" size="15" />删除轮次</div>
            </div>
            <div class="content flex-center">
                <div class="team">
                    <div class="player flex-center" @click="openPlayerPicker('home', item.round)">
                        <div v-if="item.homePlayerId">
                            <span>{{ item.homePlayerName }}</span>
                        </div>
                        <div v-else class="placeholder">请选择主队队员</div>
                        <van-icon name="arrow" size="18" />
                    </div>
                    <div class="result">
                        <van-cell :title="item.homeGoalCount === 1 ? '命中' : '未命中'">
                            <van-switch v-model="item.homeGoalCount" size="20" :active-value="1" active-color="#1565FC" :inactive-value="0" />
                        </van-cell>
                    </div>
                </div>
                <div class="line"></div>
                <div class="team">
                    <div class="player flex-center" @click="openPlayerPicker('away', item.round)">
                        <div v-if="item.awayPlayerId">
                            <span>{{ item.awayPlayerName }}</span>
                        </div>
                        <div v-else class="placeholder">请选择客队队员</div>
                        <van-icon name="arrow" />
                    </div>
                    <div class="result">
                        <van-cell :title="item.awayGoalCount === 1 ? '命中' : '未命中'">
                            <van-switch v-model="item.awayGoalCount" size="20" :active-value="1" active-color="#1565FC" :inactive-value="0" />
                        </van-cell>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="footer">
        <div class="add" @click="addRound">
            <div class="icon"><van-icon name="add-o" /></div>
            <div>添加轮次</div>
        </div>
        <div class="submit" @click="submit">提交</div>
      </div>
      
      <!-- 球员选择弹窗 -->
      <van-popup v-model="showPlayerPicker" position="bottom" round>
        <div class="player-picker">
          <div class="picker-header">
            <div class="title">选择球员</div>
            <van-icon name="cross" @click="showPlayerPicker = false" />
          </div>
          <div class="picker-content">
            <div 
              v-for="player in playerListForPicker" 
              :key="player.id" 
              class="player-item"
              :class="{ 'disabled': isPlayerDisabled(player.id), 'selected': isCurrentRoundPlayer(player.id) }"
              @click="handlePlayerClick(player)"
            >
              <div class="player-name"><span v-if="player.number">({{ player.number }})</span>{{ player.trueName }}</div>
              <van-icon name="success" v-if="isCurrentRoundPlayer(player.id)" color="#1565FC" />
              <span v-else-if="isPlayerDisabled(player.id)" class="disabled-text">已选择</span>
            </div>
            <div v-if="playerListForPicker.length === 0" class="empty">
              暂无可选球员
            </div>
          </div>
        </div>
      </van-popup>
    </div>
</template>

<script>
import { adminGetBMBktGameData, adminGetBMBktGameEventPlayerList, adminUpdatePenaltyShootoutData,getPenaltyShootoutData } from '@/api/match'
import { QNImageUtil } from '@/utils'
import Vue from 'vue';
import { Switch, Popup, Icon, Toast } from 'vant';
Vue.use(Switch).use(Popup).use(Icon).use(Toast);
export default {
    props: {
        isMe: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            id: '',
            matchId: '',
            game: {},
            homeTeam: {},
            awayTeam: {},
            homePlayerList: [],
            awayPlayerList: [],
            list: [
                { round: 1, homePlayerId: '', homeGoalCount: 0, homePlayerName: '', homePlayerNumber: '', awayPlayerId: '', awayPlayerName: '', awayPlayerNumber: '', awayGoalCount: 0 },
                { round: 2, homePlayerId: '', homeGoalCount: 0, homePlayerName: '', homePlayerNumber: '', awayPlayerId: '', awayPlayerName: '', awayPlayerNumber: '', awayGoalCount: 0 },
                { round: 3, homePlayerId: '', homeGoalCount: 0, homePlayerName: '', homePlayerNumber: '', awayPlayerId: '', awayPlayerName: '', awayPlayerNumber: '', awayGoalCount: 0 },
                { round: 4, homePlayerId: '', homeGoalCount: 0, homePlayerName: '', homePlayerNumber: '', awayPlayerId: '', awayPlayerName: '', awayPlayerNumber: '', awayGoalCount: 0 },
                { round: 5, homePlayerId: '', homeGoalCount: 0, homePlayerName: '', homePlayerNumber: '', awayPlayerId: '', awayPlayerName: '', awayPlayerNumber: '', awayGoalCount: 0 }
            ],
            showPlayerPicker: false,
            currentTeamType: '', // 'home' or 'away'
            currentRound: null
        };
    },
    computed: {
        // 获取当前选择器显示的球员列表（显示所有球员）
        playerListForPicker() {
            return this.currentTeamType === 'home' ? this.homePlayerList : this.awayPlayerList
        }
    },
    watch: {
        isMe() {
            if (this.isMe) {
                this.adminGetBMBktGameData()
            }
        }
    },
    mounted() {
        this.id = this.$route.query.id
        this.matchId = this.$route.query.matchId
        this.adminGetBMBktGameData()
    },
      methods: {
          async submit() {
              // 处理数据：只提交有效的轮次
              const result = this.getValidRounds()
              
              // 如果验证失败，不提交
              if (result.error) {
                  return
              }
              
              const validRounds = result.data
              
              // 格式化数据
              const penaltyShootoutEvents = validRounds.map(item => ({
                  round: item.round,
                  homePlayerId: item.homePlayerId || '',
                  homeGoalCount: item.homeGoalCount,
                  awayPlayerId: item.awayPlayerId || '',
                  awayGoalCount: item.awayGoalCount
              }))
              
              try {
                  const params = {
                      gameId: this.id,
                      penaltyShootoutEvents: JSON.stringify(penaltyShootoutEvents)
                  }
                  
                  const res = await adminUpdatePenaltyShootoutData(params)
                  if (res) {
                      Toast.success('提交成功')
                  }
              } catch (error) {
                  console.error('提交失败', error)
                  Toast.fail('提交失败')
              }
          },
          // 获取有效的轮次数据
          getValidRounds() {
              // 1. 先找到最后一个有数据的轮次索引
              let lastValidIndex = -1
              for (let i = this.list.length - 1; i >= 0; i--) {
                  const item = this.list[i]
                  const hasHomePlayer = item.homePlayerId !== '' && item.homePlayerId !== null
                  const hasAwayPlayer = item.awayPlayerId !== '' && item.awayPlayerId !== null
                  
                  if (hasHomePlayer || hasAwayPlayer) {
                      lastValidIndex = i
                      break
                  }
              }
              
              // 如果没有任何数据，返回空数组（允许清空）
              if (lastValidIndex === -1) {
                  return { error: false, data: [] }
              }
              
              // 2. 从第1轮到最后一个有数据的轮次，检查是否有空轮次
              const validRounds = []
              
              for (let i = 0; i <= lastValidIndex; i++) {
                  const item = this.list[i]
                  const hasHomePlayer = item.homePlayerId !== '' && item.homePlayerId !== null
                  const hasAwayPlayer = item.awayPlayerId !== '' && item.awayPlayerId !== null
                  
                  // 检查是否有数据
                  if (!hasHomePlayer && !hasAwayPlayer) {
                      // 这一轮完全没有数据，但后面还有数据，报错
                      Toast.fail(`第${item.round}轮没有数据，请补充完整`)
                      return { error: true, data: [] }
                  }
                  
                  // 检查是否是最后一轮
                  if (i === lastValidIndex) {
                      // 最后一轮允许只有一方数据
                      validRounds.push(item)
                  } else {
                      // 非最后一轮，必须两队都有数据
                      if (hasHomePlayer && hasAwayPlayer) {
                          validRounds.push(item)
                      } else {
                          Toast.fail(`第${item.round}轮数据不完整，请补充完整`)
                          return { error: true, data: [] }
                      }
                  }
              }
              
              return { error: false, data: validRounds }
          },
        adminGetBMBktGameData() {
            adminGetBMBktGameData({ gameId: this.id }).then(res => {
                this.game = res.data.game
                this.homeTeam = this.game.homeTeam
                this.awayTeam = this.game.awayTeam
            const home = new Promise((resolve, reject) => {
            adminGetBMBktGameEventPlayerList({ matchId :this.matchId ,teamId: this.game.homeTeam.id, gameId: this.id }).then(res => {
                resolve(res)
            }).catch(e => {
                reject(e)
            })
            })
            const away = new Promise((resolve, reject) => {
            adminGetBMBktGameEventPlayerList({ matchId: this.matchId, teamId: this.game.awayTeam.id, gameId: this.id }).then(res => {
                resolve(res)
            }).catch(e => {
                reject(e)
            })
            })
            this.getTeamList(home, away)
            // 获取点球大战数据
            this.getPenaltyShootoutData()
        })
        },
        // 获取点球大战数据
        getPenaltyShootoutData() {
            getPenaltyShootoutData({ gameId: this.id }).then(res => {
                console.log(res,'ress');
                const { data } = res
                if (data && data.length > 0) {
                    // 有数据，根据返回的数据填充
                    const penaltyData = data
                    this.list = penaltyData.map(item => ({
                        round: item.round,
                        homePlayerId: item.homePlayerId || '',
                        homePlayerName: item.homePlayerName || '',
                        homePlayerNumber: item.homePlayerNumber || '',
                        homeGoalCount: item.homeGoalCount || 0,
                        awayPlayerId: item.awayPlayerId || '',
                        awayPlayerName: item.awayPlayerName || '',
                        awayPlayerNumber: item.awayPlayerNumber || '',
                        awayGoalCount: item.awayGoalCount || 0
                    }))
                    
                    // 如果数据少于5轮，补充到5轮
                    const currentLength = this.list.length
                    if (currentLength < 5) {
                        for (let i = currentLength; i < 5; i++) {
                            this.list.push({
                                round: i + 1,
                                homePlayerId: '',
                                homePlayerName: '',
                                homePlayerNumber: '',
                                homeGoalCount: 0,
                                awayPlayerId: '',
                                awayPlayerName: '',
                                awayPlayerNumber: '',
                                awayGoalCount: 0
                            })
                        }
                    }
                } else {
                    // 没有数据，保持默认的5轮空数据
                    this.list = [
                        { round: 1, homePlayerId: '', homeGoalCount: 0, homePlayerName: '', homePlayerNumber: '', awayPlayerId: '', awayPlayerName: '', awayPlayerNumber: '', awayGoalCount: 0 },
                        { round: 2, homePlayerId: '', homeGoalCount: 0, homePlayerName: '', homePlayerNumber: '', awayPlayerId: '', awayPlayerName: '', awayPlayerNumber: '', awayGoalCount: 0 },
                        { round: 3, homePlayerId: '', homeGoalCount: 0, homePlayerName: '', homePlayerNumber: '', awayPlayerId: '', awayPlayerName: '', awayPlayerNumber: '', awayGoalCount: 0 },
                        { round: 4, homePlayerId: '', homeGoalCount: 0, homePlayerName: '', homePlayerNumber: '', awayPlayerId: '', awayPlayerName: '', awayPlayerNumber: '', awayGoalCount: 0 },
                        { round: 5, homePlayerId: '', homeGoalCount: 0, homePlayerName: '', homePlayerNumber: '', awayPlayerId: '', awayPlayerName: '', awayPlayerNumber: '', awayGoalCount: 0 }
                    ]
                }
            }).catch(error => {
                console.error('获取点球大战数据失败', error)
                // 失败时保持默认5轮空数据
            })
        },
        getTeamList(home, away) {
            Promise.all([home, away]).then(results => {
                console.log('success:', results)
                const home = results[0]
                const away = results[1]
                this.homePlayerList = home.data.playerList
                this.awayPlayerList = away.data.playerList
                console.log(this.homePlayerList,this.awayPlayerList,'this.homePlayerList,this.awayPlayerList');
                
            })
        },
        imageView(img, w, h) {
            if (!img) return 'https://images.snsports.cn/FrB9e_-z4Gj4879NuraIWmiVDkv_'
            return QNImageUtil.imageView(img, w, h)
        },
        addRound() {
            this.list.push({ 
                round: this.list.length + 1, 
                homePlayerId: '', 
                homeGoalCount: 0, 
                homePlayerName: '', 
                homePlayerNumber: '', 
                awayPlayerId: '', 
                awayPlayerName: '', 
                awayPlayerNumber: '', 
                awayGoalCount: 0 
            })
        },
        deleteRound(round) {
            this.list = this.list.filter(item => item.round !== round)
        },
        // 打开球员选择弹窗
        openPlayerPicker(teamType, round) {
            this.currentTeamType = teamType
            this.currentRound = round
            this.showPlayerPicker = true
        },
        // 判断球员是否被其他轮次选择（禁用状态）
        isPlayerDisabled(playerId) {
            const isSelected = this.list.some(item => {
                if (item.round === this.currentRound) return false // 排除当前轮次
                if (this.currentTeamType === 'home') {
                    return item.homePlayerId === playerId
                } else {
                    return item.awayPlayerId === playerId
                }
            })
            return isSelected
        },
        // 判断是否是当前轮次已选择的球员
        isCurrentRoundPlayer(playerId) {
            const currentItem = this.list.find(item => item.round === this.currentRound)
            if (!currentItem) return false
            
            if (this.currentTeamType === 'home') {
                return currentItem.homePlayerId === playerId
            } else {
                return currentItem.awayPlayerId === playerId
            }
        },
        // 处理球员点击
        handlePlayerClick(player) {
            // 如果是其他轮次已选的球员，不允许选择
            if (this.isPlayerDisabled(player.id)) {
                return
            }
            
            const targetItem = this.list.find(item => item.round === this.currentRound)
            if (!targetItem) return
            
            // 如果点击的是当前轮次已选的球员，则取消选择（反选）
            if (this.isCurrentRoundPlayer(player.id)) {
                if (this.currentTeamType === 'home') {
                    targetItem.homePlayerId = ''
                    targetItem.homePlayerName = ''
                    targetItem.homePlayerNumber = ''
                } else {
                    targetItem.awayPlayerId = ''
                    targetItem.awayPlayerName = ''
                    targetItem.awayPlayerNumber = ''
                }
                this.showPlayerPicker = false
                return
            }
            
            // 正常选择球员
            if (this.currentTeamType === 'home') {
                targetItem.homePlayerId = player.id
                targetItem.homePlayerName = player.trueName
                targetItem.homePlayerNumber = player.number || player.playerNumber || ''
            } else {
                targetItem.awayPlayerId = player.id
                targetItem.awayPlayerName = player.trueName
                targetItem.awayPlayerNumber = player.number || player.playerNumber || ''
            }
            
            this.showPlayerPicker = false
        }
    },
};
</script>

<style scoped lang="scss">
.penalty{
    height: calc(100vh - 50px);
    overflow: auto;
    background-color: #F8F8F8;
    padding-bottom: 100px;
    box-sizing: border-box;
    .team-box{
    background-color: #fff;
    padding: 16px 60px;
    align-items: flex-start;
    .team{
      text-align: center;
      position: relative;
      .title{
        position: absolute;
        left: -40px;
        font-size: 14px;
        bottom: 28px;
     
      }
      img{
        width: 60px;
        height: 60px;
        border-radius: 4px;
        border: 1px solid #E8E8E8;
      }
    }
    .vs{
      width: 24px;
      height: 24px;
      margin-top: 34px;
    }
    }
    .list{
        .item{
            background-color: #fff;
            .title{
                background-color: #F8F8F8;
                color: #303133;
                font-size: 14px;
                font-weight: 600;
                padding: 12px 17px;
                .delete{
                    color: #CC3232;
                    font-size: 12px;
                }
            }
            .team{
                flex: 1;
                padding: 0 28px;
                font-size: 14px;
                .placeholder{
                    color: #909399;
                }
                .player{
                   padding: 12px 0;
                   .player-number{
                       margin-left: 4px;
                       color: #606266;
                       font-size: 12px;
                   }
                }
            }
            .line{
                width: 1px;
                height: 55px;
                background-color: #D8D8D8;
            }
        }
    }
    .footer{
        position: fixed;
        bottom: 0px;
        left: 0px;
        width: 100vw;
        height: 88px;
        padding: 0 16px;
        padding-top: 5px;
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .add{
           color: #606266;
           display: flex;
           flex-direction: column;
           align-items: center;
           justify-content: center;
           font-size: 12px;
            font-weight: 500;
           .icon{
                width: 27px;
                height: 27px;
                background: #E3F1FF;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 18px;
                color: #1AA5FF;
           }
        }
        .submit{
            width: 117px;
            height: 45px;
            border-radius: 69px;
            background: #509DEA;
            text-align: center;
            color: #fff;
            font-size: 15px;
            font-weight: 500;
            line-height: 45px;
        }
    }
}
.player-picker{
    background-color: #fff;
    max-height: 60vh;
    .picker-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        border-bottom: 1px solid #EBEDF0;
        .title{
            font-size: 16px;
            font-weight: 600;
            color: #323233;
        }
    }
    .picker-content{
        max-height: 50vh;
        overflow-y: auto;
        .player-item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 16px;
            border-bottom: 1px solid #F7F8FA;
            cursor: pointer;
            &:active{
                background-color: #F7F8FA;
            }
            .player-name{
                font-size: 14px;
                color: #323233;
            }
            .disabled-text{
                font-size: 12px;
                color: #C8C9CC;
            }
            // 禁用状态
            &.disabled{
                background-color: #F7F8FA;
                cursor: not-allowed;
                .player-name{
                    color: #C8C9CC;
                }
                &:active{
                    background-color: #F7F8FA;
                }
            }
            // 当前轮次已选择状态
            &.selected{
                background-color: #EBF5FF;
            }
        }
        .empty{
            text-align: center;
            padding: 40px 0;
            font-size: 14px;
            color: #969799;
        }
    }
}
::v-deep .van-cell{
    padding: 0px !important;
}
</style>
